import { assetTypeBattery, assetTypeGenerator } from '../Constants';

/**
 * Get the input fields for the given asset type.
 *
 * @param {'battery' | 'generator'} type // The type of the asset. Either battery or generator.
 * @param {object} asset // The asset object.
 * @return {array | null} of input fields or null.
 */
export function getInputFields(type, asset) {
  const purchasePriceField = {
    label: 'Purchase price (€) *',
    name: 'purchase-price',
    inputType: 'number',
    value: asset.price,
  };

  if (type === assetTypeBattery) {
    return [
      {
        label: 'Battery name *',
        name: 'battery-name',
        inputType: 'string',
        value: asset.name,
      },
      purchasePriceField,
      {
        label: 'Battery capacity in kWh *',
        name: 'power',
        inputType: 'number',
        value: asset.capacity,
      },
      {
        label: 'Inverter capacity in kW *',
        name: 'inverter',
        inputType: 'number',
        value: asset.inverter_capacity,
      },
      {
        label: 'Minimal SoC (%) *',
        name: 'minimal-soc',
        inputType: 'number',
        value: asset.min_soc,
      },
      {
        label: 'Maximum SoC (%) *',
        name: 'maximum-soc',
        inputType: 'number',
        value: asset.max_soc,
      },
      {
        label: 'Discharge factor (%) *',
        name: 'discharge-factor',
        inputType: 'number',
        value: asset.dcac_efficiency,
      },
    ];
  }

  if (type === assetTypeGenerator) {
    return [
      {
        label: 'Generator name *',
        name: 'generator-name',
        inputType: 'string',
        value: asset.name,
      },
      {
        label: 'Generator type *',
        name: 'generator-type',
        inputType: 'select',
        value: asset.type,
      },
      purchasePriceField,
      {
        label: 'Operational costs per kWh (€/kWh) *',
        name: 'operational-cost',
        inputType: 'number',
        value: asset.operational_cost,
      },
      {
        label: 'emmissions CO2 (kg per hour) *',
        name: 'emmission-co2',
        inputType: 'number',
        value: asset.emmission_co2,
      },
      {
        label: 'emmissions NOx (kg per hour) *',
        name: 'emmission-nox',
        inputType: 'number',
        value: asset.emmission_NOx,
      },
      {
        label: 'Power rating (kW) *',
        name: 'power',
        inputType: 'number',
        value: asset.capacity,
      },
      {
        label: 'Generator minimal load ratio (%) *',
        name: 'load-ratio',
        inputType: 'number',
        value: asset.min_power_perc,
      },
    ];
  }

  return null;
}
